import { Directive, ElementRef, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[appScrollToTop]'
})
export class ScrollToTopDirective implements OnInit {
  constructor(private router: Router, private el: ElementRef) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        // ✅ Wait for route to finish rendering
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'auto' });

          // also scroll any nested scrollable container if it exists
          const element = this.el.nativeElement;
          if (element && element.scrollTop !== undefined) {
            element.scrollTop = 0;
          }
        }, 50);
      });
  }
}
